import "./App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import LaCasa from "./pages/LaCasa";
import Turismo from "./pages/Turismo";
import AprendizajeColaborativo from "./pages/AprendizajeColaborativo";
import Profesionales from "./pages/Profesionales";
import Tarifas from './pages/Tarifas';
import Contacto from "./pages/Contacto";

// Componente para volver al inicio de la página al navegar
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/la-casa" element={<LaCasa />} />
          <Route path="/turismo" element={<Turismo />} />
          <Route path="/aprendizaje-colaborativo" element={<AprendizajeColaborativo />} />
          <Route path="/profesionales" element={<Profesionales />} />
          <Route path="/tarifas" element={<Tarifas />} />
          <Route path="/contacto" element={<Contacto />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;